// extracted by mini-css-extract-plugin
module.exports = {"container":"DonateForm_container__nTcgC"};